import {
	type NavigateOptions,
	useNavigate as useTanstackNavigate,
} from '@tanstack/react-router';
import { useCallback } from 'react';
import { backOrExit } from './backOrExit';

export interface AppNavigateOptions extends NavigateOptions {
	/** When true, perform back-navigation; 'exit' closes webview on entry */
	back?: boolean | 'exit';
}

/**
 * Wrapper around TanStack's `useNavigate` that supports a `back` option.
 *
 * Usage:
 *   const navigate = useNavigate();
 *   navigate({ back: true });
 *   navigate({ to: '/search', replace: true });
 */
export function useNavigate() {
	const navigate = useTanstackNavigate();

	return useCallback(
		(options: AppNavigateOptions) => {
			if (options?.back) {
				if (backOrExit(options.back)) {
					return Promise.resolve();
				}
			}
			return navigate(options);
		},
		[navigate],
	);
}
